import React, { useState, useCallback, useEffect } from "react";

import { makeStyles } from "@material-ui/core";

import { FaArrowRight } from "react-icons/fa";

import StyledButton from "../buttons/StyledButton";
import { FIELD_TYPES, FIELD_TYPES_BY_FIELD_TYPE } from "../lib/constants";
import { formatList } from "../lib/utils";

const useStyle = makeStyles((theme) => ({
  container: {
    padding: "1rem",
  },
  rootListContainer: {
    listStyleType: "decimal",
    padding: "0 1rem",
  },
  packInfoContainer: {
    padding: "0.5rem 0",
  },
  packHeadingContainer: {
    padding: "0.5rem 0",
  },
  packHeading: {
    fontSize: "14px",
    fontWeight: "normal",
    margin: 0,
  },
  sheetInfoContainer: {
    padding: "0.5rem 0",
  },
  sheetHeading: {
    fontSize: "14px",
    fontWeight: "normal",
    margin: 0,
  },
  sheetDescription: {
    fontSize: "12px",
  },
  textMuted: {
    color: "#818181",
  },
  textError: {
    color: "red",
  },
  list__container: {
    listStyleType: "none",
    padding: 0,
  },
  list__item: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: ".5rem",
    justifyContent: "space-between",
    padding: "0.5rem 0",

    "&.deleted *": {
      textDecoration: "line-through !important",
    },
  },
  formContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: ".5rem",
    margin: "0.5rem 0",
  },
  action__container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: ".5rem",
  },
}));

export default function NavigationTaskAction(props) {
  const { params = [], onRequestParams, onCancel, onSheetClick } = props;

  const classes = useStyle(props);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [finalParams, setFinalParams] = useState([]);

  const handleOnLoad = async () => {
    try {
      const finalParams =
        (typeof onRequestParams === "function" && (await onRequestParams())) ||
        params;

      setFinalParams(finalParams);
    } catch (e) {
      console.log(`e->`, e);
    }
  };

  const getDescription = useCallback((param) => {
    if (param.message) return param.message;
    if (!param.sheets.length) return null;
    const [firstSheet] = param.sheets;

    if (param.sheets.length === 1)
      return `Your sheet: "${firstSheet.name}" has been updated successfully.`;

    return `Your following sheets has been updated successfully.`;
  }, []);

  const handleViewDetailsClick = async (e) => {
    if (!finalParams || !finalParams[0]) return;
    const [{ pack, sheets }] = finalParams;
    setIsSubmitting(true);
    
    typeof onSheetClick === "function" &&
      (await onSheetClick({ sheet: sheets[0], pack }, e));
    setIsSubmitting(false);
  };

  const handleCancel = () => {
    typeof onCancel === "function" && onCancel();
  };

  const renderSheetNavigator = () => {
    return (
      <div className={classes.container}>
        <div>
          {finalParams.map((param, i) => {
            return (
              <div key={i} className={classes.packInfoContainer}>
                <div className={classes.packHeadingContainer}>
                  <h4 className={classes.packHeading}>
                    Pack: <strong>{param.pack.name}</strong>
                  </h4>
                </div>
                <p>{getDescription(param)}</p>
                <ul className={classes.rootListContainer}>
                  {param.sheets.map((sheet, j) => {
                    return (
                      <li key={j}>
                        <div>
                          <div className={classes.sheetInfoContainer}>
                            <h5 className={classes.sheetHeading}>
                              {sheet.name}
                            </h5>
                          </div>
                          <ul className={classes.textMuted}>
                            {sheet.fields.map((field, k) => {
                              return (
                                <li key={k}>
                                  {field.name || field.field_name} (
                                  {
                                    FIELD_TYPES_BY_FIELD_TYPE[
                                      field.field_type_id
                                    ]
                                  }{" "}
                                  type)
                                  {field.field_type_id ==
                                    FIELD_TYPES.subsheet &&
                                  field.fields?.length > 0 ? (
                                    <div>
                                      fields:{" "}
                                      {formatList(
                                        field.fields.map(
                                          (field) => `"${field.field_name}"`
                                        )
                                      )}
                                    </div>
                                  ) : null}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
        <div className={classes.action__container}>
          {/* <div>
     {errorMessage && (
       <p className={classes.textError}>{errorMessage}</p>
     )}
   </div> */}
          <div></div>
          <div className={classes.actions}>
            <StyledButton disabled={isSubmitting} onClick={handleCancel}>
              Cancel
            </StyledButton>
            <StyledButton
              disabled={isSubmitting}
              color="primary"
              endIcon={<FaArrowRight color="inherit" size={12} />}
              onClick={handleViewDetailsClick}
            >
              {isSubmitting ? "Loading..." : "View details"}
            </StyledButton>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    handleOnLoad();
  }, []);

  return renderSheetNavigator();
}
